import React, { FC, useMemo } from 'react';
import format from 'date-fns/format';
import classNames from 'classnames';

interface Props {
  date: Date;
  format: string;
  className?: string;
}

export const DateFormatted: FC<Props> = ({ date, format: f, className }) => {
  const content = useMemo(() => format(date, f), [date, f]);

  return <span className={classNames('DateFormatted', className)}>{content}</span>;
};
